import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SubsidyType} from '../../models/subsidy-type.type';
import {getSubsidyConfig} from '../../subsidies.config';

@Component({
	selector: 'tvsub-subsidy-wizard-container',
	templateUrl: './subsidy-wizard-container.component.html',
	styleUrls: ['./subsidy-wizard-container.component.scss'],
	standalone: false
})
export class SubsidyWizardContainerComponent implements OnInit {
	@Input()
	currentStep: number;
	@Input()
	isDossier: boolean = false;
	@Input()
	showCompleteModal: boolean = false;
	@Input()
	steps: string[];
	@Input()
	subsidyText?: string;
	@Input()
	subsidyType?: SubsidyType;
	@Output()
	close: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	complete: EventEmitter<void> = new EventEmitter<void>();
	@Output()
	currentStepChange: EventEmitter<number> = new EventEmitter();
	@Output()
	showCompleteModalChange: EventEmitter<boolean> = new EventEmitter();

	email: string;
	showCloseModal: boolean = false;

	ngOnInit() {
		switch (this.subsidyType) {
			case 'hefboomproject':
				this.email = 'relance@toerismevlaanderen.be';
				break;
			case 'tva':
				this.email = 'toerismevoorallen@toerismevlaanderen.be';
				break;
			default:
				const config = getSubsidyConfig(this.subsidyType);

				if (config) {
					this.email = config.email || 'subsidies@toerismevlaanderen.be';

					if (!this.subsidyText) {
						this.subsidyText = config.text || `subsidie in het kader van ${config.name}`;
					}
				}
		}
	}

	onClose(close: boolean) {
		if (close) {
			this.close.emit();
		}
	}

	onComplete(complete: boolean) {
		if (complete) {
			this.complete.emit();
		}
	}

	onCompleteModal(show: boolean) {
		this.showCompleteModalChange.emit(show);
	}

	onStepChange(step: number) {
		const config = getSubsidyConfig(this.subsidyType);
		const allowStep0 = this.subsidyType === 'hefboomproject' ||
			this.subsidyType === 'ivv_sk' ||
			!config?.disableStep0;

		if (step > 0 || allowStep0) {
			this.currentStepChange.emit(step);
		}
	}
}
